import { Project } from '../../classes/project.class';
import { User } from '../../classes/user.class';
import { AsphaltPerformerPlanningEntry, ProjectExecutorPlanningEntry } from '../../services/executor-planning.service';

// Union type for entries that can appear in duplicates
export type DuplicateEntry = ProjectExecutorPlanningEntry | AsphaltPerformerPlanningEntry;

export interface ActivityOption {
    value: string;
    label: string;
    icon: string;
}

export interface TimeOption {
    value: string;
    label: string;
    hour: number;
}

export interface ContextMenuData {
    executor: User | null;
    project: Project | null;
    date: string;
    hasEntry: boolean;
    isChain: boolean;
    isNightMode: boolean;
}

export interface VisibleWeeks {
    number: number;
    dates: string[];
}

export interface ProjectSchedule {
    project: Project;
    afasProjectId: string;
    planningEntries: ProjectExecutorPlanningEntry[];
    planningByDate: { [date: string]: ProjectExecutorPlanningEntry };
    cells: PlanningCell[];
}

export interface ChainEntry {
    id: number;
    date: string;
}

export interface PlanningCell {
    date: string;
    entry: ProjectExecutorPlanningEntry | null;
    hasEntry: boolean;
    hasDuplicate: boolean;
    duplicateEntries: DuplicateEntry[];
    isWeekend: boolean;
    cssClasses: string[];
    hasAsphalt: boolean;
    hasLeave: boolean;
    activityLetter: string;
    title: string;
    chain: ChainEntry[]; // Array of planning entry IDs and dates that are part of this chain
    isFrezenAsfalt: boolean; // True when asphalt planning has both a frezen and asfalt entry
    asphaltPlanningId: number | null; // planning_id of first asphalt entry for this cell (if any)
    asphaltIndicatorLetter: string; // Letter shown in asphalt indicator (A, F, FA)
}

export interface ExecutorSchedule {
    executor: User;
    projects: ProjectSchedule[];
    collapsed?: boolean;
}

export const ACTIVITIES: ActivityOption[] = [
    { value: 'project', label: 'Project', icon: 'more_horiz' },
    { value: 'voorbereiding', label: 'Voorbereiding', icon: 'assignment' },
    { value: 'frezen', label: 'Frezen', icon: 'settings' },
    { value: 'asfalt', label: 'Asfalt', icon: 'build' },
    { value: 'frezen_asfalteren', label: 'Frezen/Asfalteren', icon: 'settings' },
    { value: 'coating', label: 'Coating', icon: 'format_paint' },
    { value: 'markering', label: 'Markering', icon: 'brush' },
    { value: 'leiding', label: 'Leiding', icon: 'supervisor_account' },
    { value: 'bermen', label: 'Bermen', icon: 'grass' },
    { value: 'boorputten', label: 'Boorputten', icon: 'construction' },
    { value: 'slaapdag', label: 'Slaapdag', icon: 'hotel' },
    { value: 'vrij', label: 'Vrij', icon: 'free_breakfast' },
];

export const TIME_OPTIONS: TimeOption[] = [
    { value: 'day', label: 'Dag (08:00)', hour: 8 },
    { value: 'night', label: 'Nacht (20:00)', hour: 20 },
];
